import * as React from 'react'
import { ComponentProps } from 'react'

import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import Actions, { type Action } from 'modules/questionnaires/components/Questionnaire/Actions'

interface Props {
  title: string
  description?: string
  illustration?: ComponentProps<typeof Icon.Large>['icon']
  actions?: Action[]
}

const EmptyState: React.FC<Props> = ({
  title,
  description,
  actions,
  illustration = 'page-edit',
}) => {
  return (
    <Box width="full" paddingY="s48" paddingX="s24">
      <Box alignItems="center" gap="s16" width="full">
        <Icon.Large icon={illustration} color="grey600" />
        <Box textAlign="center">
          <Text color="grey1000" size="300" weight="semibold">
            {title}
          </Text>
          {!!description && <Text size="300">{description}</Text>}
        </Box>
        <Actions actions={actions} />
      </Box>
    </Box>
  )
}

export default EmptyState
